import React from "react";

export default function TechTag({ label, className = "" }) {
  return (
    <span
      className={`inline-flex items-center font-mono text-[10.5px] tracking-[0.16em] uppercase px-2.5 py-1 rounded-full border border-border/80 bg-secondary/35 text-foreground/80 hover:border-primary/50 hover:text-foreground transition-colors ${className}`}
    >
      {label}
    </span>
  );
}
